import React, { useEffect, useRef } from 'react'; // Combined imports
import './intro.css';
import bg from '../../assets/image.png';
import btnImg from '../../assets/hireme.png';
import { Link } from 'react-scroll';
import gsap from 'gsap';
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

gsap.registerPlugin(ScrambleTextPlugin);
// import { useEffect, useRef } from 'react';



const Intro = () => {
    const scrambleRef = useRef(null);
    const scrambleChars = 'upperAndLowerCase';


    useEffect(() => {

        // if (scrambleRef.current) {
        //     const originalText = scrambleRef.current.textContent ?? '';
        // }

        const scrambleQuote = (ref, text) => {

            const tl = gsap.timeline({});

            // Show quote with scramble in
            tl.to(ref.current, {
            delay: Math.random() * 5, // Stagger the appearance
            duration: 1,
            opacity: 1,
            scrambleText: { text, chars: scrambleChars, revealDelay: 0.5, speed: 1 },
            ease: 'power2.out',
            })
        };

        scrambleQuote(scrambleRef, scrambleRef.current?.textContent ?? '');
        const tl = gsap.timeline({
        id: "text-scramble",
        defaults: { ease: "none" }
        });

        // gsap.set(".construction", {
        // opacity: 0
        // });

        // tl.to(".construction", {
        // scrambleText: {
        //     text: "Perpetually under construction (WIP)...",
        //     chars: "lowerCase"
        // },
        // duration: 2
        // })

    }, []);

    return (
        <section id="intro">
            <div className="introContent">
                <span className="hello">Hello,</span>
                <span className="introText">I'm <span className="introName">Alex</span> <br />Full stack Developer</span>
                <p className="introPara">I am a budding dev with a passion for creating valuable UI and effective backend solutions<br /> for a cohesive user experience.</p>
                <span className="construction" ref={scrambleRef}>under construction...</span>
                {/*<Link><button className="btn"><img src={btnImg} alt="Hire" className='btnImg'/> Hire Me</button></Link>*/}
            </div>
            {/*<img src={bg} alt="Profile" className="bg" />*/}
        </section>
    );
}

export default Intro;